/* eslint-disable camelcase */
/* @flow strict */

import * as React from 'react';
import CollapsedPanel from '/client/src/components/panel/collapsedPanel';
import ReactSummernote from 'react-summernote';
import SimpleInput from '/client/src/components/forms/simpleInput';
import SimpleCheckbox from '/client/src/components/forms/checkbox';
import { CTooltip, CTooltipLabel, CTooltipText } from '/client/src/components/tooltip/';
import { phoneRegexp, SummenrNoteToolbar } from '/client/src/constants/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import previewEmailHTMLString from '../templates/preview_email';
import { getTzStar } from '/client/src/utils/jstz';
import { Format, html_encode, getWordsCount } from '/client/src/utils/string';


import moment from 'moment';
import validateConfirmEmail from '../validator/confirmationEmail';

type PropsType = {
  isSetConfirmEmail: boolean,
  confirmationEmailGreeting: string,
  confirmationEmailSupportEmail: string,
  confirmationEmailSupportPhone: string,
  isConfirmationEmailIncludeTickets: boolean,
  isSendEmailReminders: boolean,
  handleChangeInput: () => void,
  handleControlEmailChecked: () => void
};

const Email = ({
  isSetConfirmEmail,
  confirmationEmailGreeting,
  confirmationEmailSupportPhone,
  confirmationEmailSupportEmail,
  isSendEmailReminders,
  isConfirmationEmailIncludeTickets,
  handleChangeInput,
  handleControlEmailChecked
}: PropsType): React.Element<typeof React.Element> => {
  const _limit = 7500;
  const randomIndex = _.random(1, Date.now());
  const context = React.useContext(DefaultContainerContext);
  const eventContext = React.useContext(EventDetailContainerContext);
  const ReactSummernoteRef = React.useRef(null);
  const vMsgRef = React.useRef(null);
  const [isShowLimitLabel, toggleShowLimitLabel] = React.useState(false);
  const [isShowLimitWarning, toggleShowLimitWarning] = React.useState(false);
  const [great, handleChangeGreat] = React.useState(confirmationEmailGreeting);
  const [phone, handleChangePhone] = React.useState(confirmationEmailSupportPhone);
  const [email, handleChangeEmail] = React.useState(confirmationEmailSupportEmail);
  const [remEmail, handleRemEmail] = React.useState(isSendEmailReminders);
  const [tickEmail, handleTickEmail] = React.useState(isConfirmationEmailIncludeTickets);

  const openConfirmationEmailPreview = () => {
      const newwin = window.open('about:blank');
      const btime = _.get(eventContext, 'eventDetail.begin_time_utc', null);
      const etime = _.get(eventContext, 'eventDetail.end_time_utc', null);
      const tz_id = _.get(eventContext, 'eventDetail.time_zone_id', null);
      const tz_star = getTzStar(tz_id);
      const moment_btime_utc = moment.utc(btime);
      const moment_etime_utc = moment.utc(etime);
      const s1 = moment_btime_utc.tz(tz_star).format("dddd, MMM D[<sup style='font-size:18px'>th</sup>]");
      const s2 = `${moment_btime_utc.tz(tz_star).format('h:mm a')  } - ${
            moment_etime_utc.tz(tz_star).format('h:mm a')
            } (${  moment_btime_utc.tz(tz_star).format('zz')})`;
      const x1 = _.get(eventContext, 'eventDetail.image_crop_info.x1', 0);
      const x2 = _.get(eventContext, 'eventDetail.image_crop_info.x2', 0);
      const y1 = _.get(eventContext, 'eventDetail.image_crop_info.y1', 0);
      const y2 = _.get(eventContext, 'eventDetail.image_crop_info.y2', 0);

      const imageUrlParams = `maxwidth=800&crop=(${encodeURIComponent(`${x1},${y1},${x2},${y2}`)})`;
      const imgSrc = `${_.get(eventContext, 'eventDetail.image_url')}?${imageUrlParams}`;

      const html = Format(previewEmailHTMLString, {
          user_name: '[username]',
          merchant_name: html_encode(_.get(context, 'profileCurrent.company_name', '')),
          event_name: html_encode(_.get(eventContext, 'eventDetail.name', '')),
          event_time: `${s1  }<br/>${  s2}`,
          event_image: imgSrc,
          event_location: html_encode(_.get(eventContext, 'eventDetail.location')),
          event_point: `${_.get(eventContext, 'eventDetail.lat')},${_.get(eventContext, 'eventDetail.lng')}`,
          map_zoom: _.get(eventContext, 'eventDetail.map_zoom'),
          email_greeing: great || _.get(eventContext, 'eventDetail.confirmation_email_greeting'),
          contact_tel: phone || _.get(context, 'profileCurrent.phone_number', ''),
          contact_email: email || _.get(context, 'profileCurrent.email', ''),
          show_date_and_time_style: _.get(eventContext, 'eventDetail.show_event_time_and_date') ? '' : 'display:none'
      });

      newwin.opener = null;
      newwin.document.write(html);
      newwin.document.close();
  };

  const resetPastedTextStyles = (e: any) => {
    const clipboardData = ((e.originalEvent || e).clipboardData || window.clipboardData);
    const bufferText = clipboardData.getData('Text');
    const bufferHtml = clipboardData.getData('text/html');

    if (bufferHtml.indexOf('SparxoCopy') > -1) {
      // allow html markup
    } else {
    const p = bufferText.split('\n');

    let text = '';

       for (let i = 0; i < p.length; i++) {
           const s = $('<p></p>').text(p[i]).html();

           text += `<p>${s}</p>`;
       }

       if (text !== '') {
           document.execCommand('insertHTML', false, text);
       }
       e.preventDefault();
      }
  };

  return (
    <CollapsedPanel
      status={isSetConfirmEmail}
      title='Customize email confirmation page'
      onChange={(status: boolean): any => handleControlEmailChecked(status)}
    >
      <div className="form-group SimpleInput ReactSummernote">
        <label htmlFor="eventUrl">Email Greeting</label>
        <React.Suspense>
          {navigator ?
            <div className={`js-anchor-email js-anchor-event-description ${isShowLimitWarning ? 'validationElement' : ''}`}
              style={{
              position: 'relative'
            }}
            >
            <ReactSummernote
              ref={ReactSummernoteRef}
              children={<div dangerouslySetInnerHTML={{ __html: great }} />}
              options={{
                lang: 'en-US',
                height: 350,
                dialogsInBody: true,
                toolbar: SummenrNoteToolbar
              }}
              onInit={() => {
                setTimeout(() => {
                  const resizebleEl = document.querySelector('.js-anchor-email .note-editable.panel-body');

                  if (resizebleEl) {
                    resizebleEl.style.resize = 'vertical';
                  }
                }, 1000);
              }}
              onPaste={(e): void => resetPastedTextStyles(e)}
              onChange={(content: string) => {
                const editorField = _.get(ReactSummernoteRef, 'current.editor[0].parentNode.parentNode', null);

                if (editorField) {
                  editorField.querySelector('.note-editable').classList.remove('validationElement');
                }
                const _isShowLimitWarning = getWordsCount(content) - 11 > _limit;

                toggleShowLimitWarning(_isShowLimitWarning);
                vMsgRef.current.style.display = _isShowLimitWarning ? 'block' : 'none';


                handleChangeGreat(content);
                handleChangeInput({
                  target: {
                    name: 'confirmation_email_greeting',
                    value: content
                  }
                });
              }}
              onFocus={() => {
                toggleShowLimitLabel(true);
              }}
              onBlur={() => {
                toggleShowLimitLabel(false);
              }}
            />
              {isShowLimitLabel &&
              <span className='SimpleInput__limitPlaceholder SimpleInput__limitPlaceholder-summernote'>
                {getWordsCount(great)}/{_limit}
              </span>
            }

            <div
              className='ReactSummernote-vMsg vMsg'
              ref={vMsgRef}
            >
              {isShowLimitWarning ?
                `Please enter no more than ${_limit} characters.` :
                'This field is required.'
              }
            </div>
            </div> : null
          }
        </React.Suspense>
      </div>

      <div className='row'>
        <div className="col-md-4">
          <SimpleInput
            name={'confirmationEmailSupportEmail'}
            id={'confirmationEmailSupportEmail'}
            label='Customer Support Email'
            value={email}
            onChange={(e: any) => {
              handleChangeEmail(e.target.value);
            }}
            onBlur={() => {
              validateConfirmEmail(email, '');
              handleChangeInput({
                target: {
                  name: 'confirmation_email_support_email',
                  value: email
                }
              });
            }}
            validator={!!email ? {
              text: 'Please enter a proper email address.'
            } : false}
          />
        </div>
        <div className="col-md-4">
          <SimpleInput
            name={'confirmationEmailSupportPhone'}
            id={'confirmationEmailSupportPhone'}
            label='Customer Support Phone'
            value={phone}
            onChange={(e: any) => {
              if (phoneRegexp.test(e.target.value)) handleChangePhone(e.target.value);
            }}
            onBlur={() => {
              handleChangeInput({
                target: {
                  name: 'confirmation_email_support_phone',
                  value: phone
                }
              });
            }}
            validator={!!phone ? {
              text: 'Please enter a proper phone.'
            } : false}
          />
        </div>
      </div>

      <SimpleCheckbox
        label='Attach tickets to confirmation email'
        component={
          <CTooltip>
            <CTooltipLabel standart>?</CTooltipLabel>
            <CTooltipText>
              Barcodes are suggested for all <br />
              ticketed events that require <br />
              guest to be tracked for check-in or registration
            </CTooltipText>
          </CTooltip>
        }
        checked={tickEmail}
        callBack={(status: boolean) => {
          handleTickEmail(status);

          handleChangeInput({
            target: {
              name: 'is_confirmation_email_include_tickets',
              value: status
            }
          });
        }}
      />

      <SimpleCheckbox
        label='Send event reminder emails'
        checked={remEmail}
        callBack={(status: boolean) => {
          handleRemEmail(status);
          handleChangeInput({
            target: {
              name: 'is_send_email_reminders',
              value: status
            }
          });
        }}
      />

      <a
        className="a-group"
        style={{ cursor: 'pointer' }}
        onClick={() => openConfirmationEmailPreview()}
      >
        <i className="icon icon-eye a-group-addon" style={{ marginRight: '1rem' }} />
        <span>Preview confirmation email</span>
      </a>
    </CollapsedPanel>
  );
};

export default Email;
